import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        flexGrow: 1
    },
    buttonToolbar: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        paddingLeft: '2rem',
        flexBasis: 'auto' as const
    },
    walletsGridContainer: { flexGrow: 1 },
    gridContainer: {
        minHeight: '340px',
        flexGrow: 1
    },
    grid: { position: 'relative' as const },
    exportButton: {
        position: 'absolute' as const,
        top: '.25rem',
        right: '-3.5rem',
        zIndex: 10
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    },
    pageSelectorContainer: { padding: '0 0 1rem 1.5rem' }
});